import { CCol, CFormLabel, CFormSelect } from '@coreui/react-pro'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { SEARCH_LIMIT, SEARCH_METHOD, SETTINGS_CODE } from 'src/constants/Constants'

const DefaultSearch = (props) => {
  const { searchParams, handleSearchChange, sortBy, gridSize = 3, t } = props

  const settings = useSelector((state) => state.settings?.settings)

  const pageLimitOptions = useMemo(() => {
    const perPageSetting = settings.find(
      (setting) => setting.code === SETTINGS_CODE.PER_PAGE,
    )?.value
    const { min, max } = JSON.parse(perPageSetting || '{}')
    const options = min && max ? SEARCH_LIMIT.filter((x) => x < max && x > min) : SEARCH_LIMIT
    return [min, ...options, max]
  }, [settings])

  return (
    <>
      <CCol md={gridSize} className="mb-3 mb-md-2">
        <CFormLabel htmlFor={t('sort-by', { ns: 'common' })}>
          {t('sort-by', { ns: 'common' })}
        </CFormLabel>
        <CFormSelect
          id={t('sort-by', { ns: 'common' })}
          name="order_by"
          value={searchParams?.order_by || ''}
          onChange={handleSearchChange}
        >
          <option value="" disabled key={'sort'}>
            {t('select-dropdown', { ns: 'common' })}
          </option>
          {sortBy?.map((sortBy, i) => (
            <option value={sortBy} key={'sort' + i}>
              {t(sortBy)}
            </option>
          ))}
        </CFormSelect>
      </CCol>
      <CCol md={gridSize} className="mb-3 mb-md-2">
        <CFormLabel htmlFor={t('sort', { ns: 'common' })}>{t('sort', { ns: 'common' })}</CFormLabel>
        <CFormSelect
          id={t('sort', { ns: 'common' })}
          name="sort_method"
          value={searchParams?.sort_method || ''}
          onChange={handleSearchChange}
        >
          {SEARCH_METHOD?.map((method, index) => {
            return (
              <option key={index + method} value={method}>
                {t(method, { ns: 'common' })}
              </option>
            )
          })}
        </CFormSelect>
      </CCol>
      <CCol md={gridSize} className="mb-3 mb-md-2">
        <CFormLabel htmlFor={t('page-limit', { ns: 'common' })}>
          {t('page-limit', { ns: 'common' })}
        </CFormLabel>
        <CFormSelect
          id={t('page-limit', { ns: 'common' })}
          name="limit"
          value={searchParams?.limit || ''}
          onChange={handleSearchChange}
        >
          {pageLimitOptions?.map((value, index) => {
            return (
              <option key={index + value} value={value}>
                {value} {t('per-page', { ns: 'common' })}
              </option>
            )
          })}
        </CFormSelect>
      </CCol>
    </>
  )
}

export default DefaultSearch
